import React, { useState } from 'react';
import { NODE_ICONS } from './CustomNode';

const NODE_TYPES = [
  {
    id: 'Default',
    name: 'Default Node',
    icon: NODE_ICONS['Default'],
    description: 'Use the prompt field to give instructions on what the agent should do at this point in the conversation.'
  },
  {
    id: 'Transfer Call',
    name: 'Transfer Call',
    icon: NODE_ICONS['Transfer Call'],
    description: 'Transfer nodes move the current call to a different number.'
  },
  {
    id: 'End Call',
    name: 'End Call',
    icon: NODE_ICONS['End Call'],
    description: 'This is how you terminate your dialogFlows and end your calls.'
  },
  {
    id: 'Vector DB Knowledge Base',
    name: 'Vector DB Knowledge Base',
    icon: NODE_ICONS['Vector DB Knowledge Base'],
    description: 'Blocks of text we can pass to the Agent to answer specific questions or access useful information.'
  },
  {
    id: 'Wait for Response',
    name: 'Wait for Response',
    icon: NODE_ICONS['Wait for Response'],
    description: 'Similar to Default Node but equipped with the ability to wait if the user requires time to respond.'
  },
  {
    id: 'Webhook',
    name: 'Webhook',
    icon: NODE_ICONS['Webhook'],
    description: 'Execute webhooks at any point during the conversation.'
  },
  {
    id: 'Transfer Dialog Flow',
    name: 'Transfer Dialog Flow',
    icon: NODE_ICONS['Transfer Dialog Flow'],
    description: 'Transfer the conversation to another Dialog Flow.'
  },
  {
    id: 'Custom Tool',
    name: 'Custom Tool',
    icon: NODE_ICONS['Custom Tool'],
    description: 'Create custom integrations and tools.'
  },
  {
    id: 'Press Button',
    name: 'Press Button',
    icon: NODE_ICONS['Press Button'],
    description: 'Handle button press interactions.'
  }
];

const AddNodePanel = ({ isOpen, onClose, onAddNode }) => {
  const [searchTerm, setSearchTerm] = useState('');
  
  if (!isOpen) return null;

  const filteredNodes = NODE_TYPES.filter(node => 
    node.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    node.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="fixed inset-0 z-50 md:inset-auto md:right-0 md:top-0 md:bottom-0 md:w-[400px]">
      {/* Backdrop - only on mobile */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 md:hidden" 
        onClick={onClose}
      />
      
      {/* Panel */}
      <div className="fixed inset-0 top-16 md:top-0 md:inset-auto md:right-0 md:bottom-0 md:w-[400px] bg-white shadow-lg flex flex-col">
        {/* Header */}
        <div className="p-4 border-b sticky top-0 bg-white z-10">
          <h2 className="text-xl font-semibold mb-4">Add New Node</h2>
          
          {/* Search bar with close button */}
          <div className="flex gap-2">
            <div className="relative flex-1">
              <input
                type="text"
                placeholder="Search nodes..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full px-4 py-2 pr-10 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              {searchTerm && (
                <button
                  onClick={() => setSearchTerm('')}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                >
                  ×
                </button>
              )}
            </div>

            {/* Close button */}
            <button
              onClick={onClose}
              className="px-4 py-2 text-gray-500 hover:text-gray-700 border rounded-lg hover:bg-gray-50"
            >
              Close
            </button>
          </div>
        </div>
        
        {/* Node list */}
        <div className="flex-1 overflow-y-auto">
          <div className="p-4 space-y-2">
            {filteredNodes.map((nodeType) => (
              <button
                key={nodeType.id}
                onClick={() => {
                  onAddNode(nodeType.id);
                  onClose();
                }}
                className="w-full p-4 border rounded-lg hover:bg-gray-50 transition-colors text-left flex items-start gap-3"
              >
                <span className="text-2xl flex-shrink-0">{nodeType.icon}</span>
                <div className="min-w-0 flex-1">
                  <h3 className="font-medium truncate">{nodeType.name}</h3>
                  <p className="text-sm text-gray-600 line-clamp-2">{nodeType.description}</p>
                </div>
              </button>
            ))}

            {filteredNodes.length === 0 && (
              <div className="text-center py-8 text-gray-500">
                <p>No nodes found matching "{searchTerm}"</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddNodePanel; 